<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

jQuery(document).ready(function () {
  $(".custom-badge").prepend('<img src="https://cdn.shopify.com/s/files/1/0563/0708/9482/files/stopwatch-24-wht.png?v=1661785286" width="18" height="18" />&nbsp;');
  $("[data-product-id=6921441411146] .custom-badge").append("1 to 2 Seconds");
  $("[data-product-id=6921461268554] .custom-badge").append("1 Second");
  $("[data-product-id=6921442984010] .custom-badge").append("0.5 to 1 Second");
  $("[data-product-handle=i-do] .custom-badge").append("1 to 2 Seconds");
  $("[data-product-handle=black-widow-adhesive] .custom-badge").append("1 Second");
  $("[data-product-handle=she-express] .custom-badge").append("0.5 to 1 Second");
});